import { render, staticRenderFns } from "./FallbackSelfie.vue?vue&type=template&id=1864e3ac&scoped=true&"
import script from "./FallbackSelfie.vue?vue&type=script&lang=ts&"
export * from "./FallbackSelfie.vue?vue&type=script&lang=ts&"
import style0 from "./FallbackSelfie.vue?vue&type=style&index=0&id=1864e3ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1864e3ac",
  null
  
)

export default component.exports